<template>
    <div class="content-legalinformation">
        <div class="legal-text">
            <h1>Impressum</h1>
            <p>Angaben gemäß § 5 TMG<br />
            <strong>Toni Michael Sattler</strong><br />
            Heinrich-Müller-Stieg 6<br />
            22041 Hamburg<br /><br />
            <strong>Kontakt</strong><br />
            Telefon: +49 157 52574433<br />
            E-Mail: kontakt@toni-sattler.de<br />
            <!--<strong>Umsatzsteuer-ID</strong><br />
            Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
            DE314338769--></p>

            <p><strong>Streitschlichtung</strong><br />
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br />
            https://ec.europa.eu/consumers/odr.<br />
            Unsere E-Mail-Adresse finden Sie oben im Impressum.<br />
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer<br />
            Verbraucherschlichtungsstelle teilzunehmen.</p>

            <p><strong>Umsetzung der Webseite</strong><br />
            Laura Heimann<br />
            <a href="https://laura.media" target="_blank">https://laura.media</a></p>

            <p><strong>Fotos geschossen und editiert von:</strong><br />
            Brian Sommer</p>

            <p><strong>Haftung für Inhalte</strong><br />
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.<br /></p>

            <p><strong>Haftung für Links</strong><br />
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>

            <p><strong>Urheberrecht</strong><br />
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PageLegalInformation'
    };
</script>

<style scoped lang="less">
    .legal-text {
        max-width: 1200px;
        width: 90%;
        margin: 0 auto;
        padding-bottom: 50px;
        color: rgba(0,0,0,0.6);
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
        user-select: text;

        & strong, & h1 {
            color: #000;
        }
        & p {
            line-height: 1.5em;
            margin: 25px 0px;
        }
    }
</style>